module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "fire-cover.f0f94f02.png";